import isMobile from "is-mobile";
import React, { useEffect, useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config/config";
import { ItemCategoryInfoList } from "../../constants/const";
import { ItemCategory } from "../../constants/enum/enum";
import { IFrameEvents } from "../../constants/enum/iframe";
import useIFrameEvent from "../../hook/useIFrameEvent";
import useWallet from "../../hook/useWallet";
import { isDefined } from "../../utils/utils";

const MapGame = () => {
  const { city } = useParams(); // Extract the city parameter from the route
  const navigate = useNavigate();
  const searchParams = useMemo(
    () => new URLSearchParams(window.location.search),
    []
  );
  const [iframeSrc, setIframeSrc] = React.useState("");
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    // Build the base iframe URL
    let iframeUrl = `${
      false ? "http://localhost:3000/dist" : config.mapDomain
    }/?city=${city}`;

    // Append slotX and slotY if available
    const slotX = searchParams.get("slotX");
    const slotY = searchParams.get("slotY");
    if (slotX && slotY) {
      const queryParams = new URLSearchParams();
      if (slotX) queryParams.append("slotX", slotX);
      if (slotY) queryParams.append("slotY", slotY);
      iframeUrl += `&${queryParams.toString()}`;
    }

    setIframeSrc(iframeUrl);
  }, [city, searchParams]);

  const handleChangeCity = (eventName: IFrameEvents, eventParam: any) => {
    switch (eventName) {
      case IFrameEvents.CHANGE_CITY:
        const { cityId } = eventParam;
        if (isDefined(cityId)) {
          navigate(`/map/${cityId}`);
        }
        break;
      case IFrameEvents.ENTER_BUSINESS:
        const { businessType, businessId } = eventParam;
        if (isDefined(businessType) && isDefined(businessId)) {
          navigate(
            `/${
              ItemCategoryInfoList[ItemCategory.BUSINESS]?.businessLinks![
                businessType
              ]
            }/${businessId}`
          );
        }

        break;
    }
  };

  useWallet(iframeRef);
  useIFrameEvent(iframeRef, handleChangeCity);

  return (
    <div style={{ width: "100%", height: "calc(100vh - 107px)" }}>
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        title="City Map"
        style={{
          width: "100%",
          height: isMobile() ? "calc(100% + 74px)" : "calc(100% + 60px)",
          border: "none",
          marginTop: "-64px",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default MapGame;
